<template>
  <article class="page-statistics-service">
    <!-- table panel -->
    <crm-panel class="table-panel" >
      <!-- total time -->
      <section class="tips-container">
        <span class="tips-container_text">数据统计于{{ totalTime }}</span>
      </section>
      <!-- toolbar -->
      <section class="select-container">
         <el-form :inline="true">
           <span class="select-container_label">服务总量统计</span>
            <el-form-item>
              <el-select v-model="timeRangeAlias" @change="handleTimeRangeChange($event)">
                <chart-total-time-options />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-show="isShown"
                v-model="time"
                value-format="yyyy-MM-dd"
                :editable="false"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
         </el-form>
      </section>
      <!-- total block -->
      <section class="total-container">
        <div
          class="total-container_block"
          v-for="totalBlock in totalBlockList"
          :key="totalBlock.tipText">
          <crm-block v-bind="totalBlock" />
        </div>
      </section>
      <!-- table -->
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%">
        <el-table-column
          prop="serviceType"
          label="服务类型"
          align="center">
        </el-table-column>
        <el-table-column label="订单量">
          <el-table-column
            prop="success"
            label="成功"
            align="center">
          </el-table-column>
          <el-table-column
            prop="cancel"
            label="取消"
            align="center">
          </el-table-column>
          <el-table-column
            prop="failure"
            label="失败"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="orderTotal"
          label="订单总量"
          align="center">
        </el-table-column>
        <el-table-column
          prop="successRate"
          label="成功率"
          align="center">
          <template slot-scope="{ row }">
            {{ row.successRate }}%
          </template>
        </el-table-column>
      </el-table>
    </crm-panel>
  </article>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { serviceCount } from 'crm-common';

import { conversion } from '@/scripts/utils';
import http from '~services/axios';
import CHART_TOTAL_BLOCK_PROPS from '~services/constant/statistics/service-total-block';
import CHART_API_CONFIG from '~api/statistics/service-api-config';
import getTimeRangeByAlias from '~services/time-range';

import ChartTotalTimeOptions from '@/components/business/datastatistics/chart-total-time-options';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmBlock from '@/components/base/crmBlock';

const { apiFactory, totalFactory, chartFactory: optionFactory } = serviceCount;
const diagramCommonApi = apiFactory(http, CHART_API_CONFIG);

// crm-common包中对每个图表定义的名称
const CHART_NAME = 'service';

/**
 * TABLE_GETTER_NAME: vuex-store里对应的表格数据getter名称
 * TABLE_ACTION_NAME: vuex-store里对应的表格数据获取action名称
 *  */
const TABLE_GETTER_NAME = 'serviceTotalData';
const TABLE_ACTION_NAME = 'getServiceTotalData';

// echarts instance
// let chart;
// const echartsConfig = {
//   devicePixelRatio: window.devicePixelRatio,
// };
const defaultDataFormat = 'YYYY-MM-DD';

export default {
  components: {
    CrmPanel,
    CrmButton,
    CrmBlock,
    ChartTotalTimeOptions,
  },
  filters: {
    conversion,
  },
  data() {
    const yestoday = moment().dates(moment().date() - 1).format(defaultDataFormat);

    return {
      loading: false,
      isShown: false,
      time: [],
      totalTime: yestoday,
      timeRangeAlias: 'this-month',
      totalBlockList: [],
      tableData: [],
      tableSearchForm: {
        startDate: moment().startOf('month').format(defaultDataFormat),
        endDate: moment().endOf('month').format(defaultDataFormat),
      },
    };
  },
  mounted() {
    this.getDiagram();
  },
  methods: {
    renderTotalTime() {
      this.totalTime = moment().dates(moment().date() - 1).format(defaultDataFormat);
    },
    handleTimeRangeChange(timeAlias) {
      if (timeAlias === 'self-time') {
        this.isShown = true;
      } else {
        this.isShown = false;
        const { startTime, endTime } = getTimeRangeByAlias(timeAlias, defaultDataFormat);
        this.tableSearchForm = {
          startDate: startTime,
          endDate: endTime,
        };
        this.getDiagram();
      }
    },
    handleSelfTimeSearch() {
      const { startTime, endTime } = getTimeRangeByAlias(timeAlias, defaultDataFormat);
      this.tableSearchForm = {
        startDate: this.time[0],
        endDate: this.time[1],
      };
      this.getDiagram();
    },
    // handleTimeRangeChange(timeAlias) {
    //   const { startTime, endTime } = getTimeRangeByAlias(timeAlias, defaultDataFormat);
    //   this.tableSearchForm = {
    //     startDate: startTime,
    //     endDate: endTime,
    //   };
    //   this.getDiagram();
    // },
    renderTotalBlock(data) {
      // total: [{ key: 'totalOrder', value: 100, alias: '总订单量' }, {}, ...]
      const total = totalFactory(CHART_NAME, data);
      this.totalBlockList = total.map(({ key, value }) => {
        const totalComponentProps = CHART_TOTAL_BLOCK_PROPS[key];
        totalComponentProps.theme = value;
        return totalComponentProps;
      });
    },
    renderTable(data) {
      data.forEach((item) => {
        item.orderTotal = item.success + item.cancel + item.failure;
        item.successRate = ((item.success / item.orderTotal) * 100).toFixed(2);
      });
      this.tableData = data;
    },
    // chart ajax
    getDiagram() {
      diagramCommonApi(CHART_NAME, this.tableSearchForm).then((res) => {
        const { results, totalOrder, totalSuccessRate } = res.data;
        this.renderTotalTime();
        this.renderTotalBlock({ totalOrder, totalSuccessRate });
        this.renderTable(results);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-statistics-service {
  display: flex;
  flex: 1;
  width: 100%;

  // 表格面板
  .table-panel {
    padding-bottom: 20px;
    .tips-container {
      margin: -20px -20px 0;
      background: rgba(240, 183, 98, 0.1);
      height: 28px;
      line-height: 28px;
      &_text {
        padding-left: 20px;
        color: #7a84b7;
      }
    }
    .select-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      &_label {
        line-height: 42px;
        font-size: 24px;
        color: #7A84B7;
        padding-right: 30px;
      }
    }
    .total-container {
      display: flex;
      flex-wrap: wrap;
      &_block {
        margin-left: 20px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
